import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import MainLayout from '../components/MainLayout';
import jwt_decode from 'jwt-decode';
import { useSelector } from 'react-redux';

interface Props {
  component: any,
  path: string,
  exact: boolean,
}

const PrivateRoute: React.FC<Props> = ({component: Component, path, exact, ...rest}) => {
  const isAuthenticated = useSelector((state: any) => state.auth.isAuthenticated);
  
  const token = localStorage.getItem('token');

  const isValid = React.useMemo(() => {
    if (!token) return false;
    const data: any = jwt_decode(token);

    if (data.exp <= Date.now().valueOf() / 1000) return false;

    return true;
  }, [token]);

  return (
    <Route
      path={path}
      render={(props) =>
        !isValid && !isAuthenticated  ? (
          <Redirect to={{pathname: '/login'}} />
        ) : (
          <MainLayout>
            <Component {...props} />
          </MainLayout>
        )
      }
      {...rest}
    />
  );
};

export default PrivateRoute;
